import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function StickyCTA({ show }) {
  if (!show) return null;
  return (
    <div className="fixed bottom-6 right-6 z-40 fade-up">
      <Link
        to="/calificacion"
        data-testid="sticky-cta-formulario"
        className="btn-primary shadow-2xl !py-3 !px-5"
      >
        <Sparkles size={14} /> Aplicar ahora
      </Link>
    </div>
  );
}
